import React from 'react';
import ReactGA from 'react-ga';

import PageContent from '../../components/Layout/PageContent';
import { TableGridApiContextProvider } from '../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import BenchmarkListTable from './BenchmarkListTable/BenchmarkListTable';

const BenchwiseListPage: React.FunctionComponent = () => {
  ReactGA.pageview(window.location.pathname);
  return (
    <PageContent isPageHeightAuto={false}>
      <TableGridApiContextProvider>
        <BenchmarkListTable benchwiseOnly={true} />
      </TableGridApiContextProvider>
    </PageContent>
  );
};

export default BenchwiseListPage;
